import {SET_PENDING_TRANSACTIONS,NEW_EVENT,SET_LOADING} from '../../types';
import { sendTx } from '../../helpers/bc';
import {decrypt} from '../../helpers/crypto';
import {lowestDenom, fromUnit} from '../../../config';
import { getNRGBalance, getSpendableOutpoints } from '../../passport/get';
import {payNEO,payBTC,payETH,payLSK,payWAV,payNRG,payEMB,payDAI,payUSDT} from '../../transfers/set';
import { getWallet } from '../../helpers/wallet';
import {
  createTakerOrderTransaction
} from 'bc-sdk/dist/transaction'


export function placeTakerOrder({ password,order },done){
  return async function(dispatch,getState) {
    try {
      dispatch({type:SET_LOADING,payload:true})
      const state = getState()

      let { privateKey: bcPrivateKeyHex, address: bcAddress } = getWallet(getState, 'nrg', password)

      let collateral = order.takeAmount ? order.collateralizedNrg * order.takeAmount / order.amount : order.collateralizedNrg;

      let {denomination,asset,type} = state.ui_marketplace.market;

      let sendsFromChain = state.ui_marketplace.orderType === 'BUY' ? denomination : asset;
      let receivesToChain = state.ui_marketplace.orderType === 'BUY' ? asset : denomination;
      let sendsFromAddress = state.passport.wallet[sendsFromChain.toLowerCase()].address;
      let receivesToAddress = state.passport.wallet[receivesToChain.toLowerCase()].address;
      const spendableOutpointsList = state.passport.spendableOutpoints

      const makerOrderInfo = {
        doubleHashedBcAddress: order.doubleHashedBcAddress,
        nrgUnit: order.nrgUnit.toString(),
        collateralizedNrg: order.collateralizedNrg.toString(),
        txHash: order.txHash,
        txOutputIndex: order.txOutputIndex,
        base: order.base,
        fixedUnitFee: order.fixedUnitFee
      }

      const tx = createTakerOrderTransaction(
        spendableOutpointsList,
        sendsFromAddress.toString(), receivesToAddress.toString(),
        makerOrderInfo,
        bcAddress.toString(), bcPrivateKeyHex.toString(),
        collateral.toString(), '1'
      )

      let data = await sendTx(state.settings.settings, tx)

      if(data.txHash){
        getNRGBalance(dispatch, state)
        getSpendableOutpoints(dispatch,state)

        dispatch({
          type:SET_PENDING_TRANSACTIONS,
          payload: {hash:data.txHash,type:"Trade Order (Taker)",amount:collateral,chain:"NRG"}
        });

        let amount = collateral / order.collateralizedNrg * (state.ui_marketplace.orderType === 'SELL' ? order.amount : order.amount*order.price)

        console.log({amount})
        if(getState().settings.settings.autoTrader){
          dispatch({
            type:NEW_EVENT,
            payload: {isMaker:false,txHash:data.txHash,from:sendsFromAddress.toString(),to:order.receivesToAddress,chain:order.receivesToChain.toUpperCase(),amount,password}
          })
        }

        dispatch({type:SET_LOADING,payload:false})
        done(null,data);
      }
      else {
        console.log({data})
        dispatch({type:SET_LOADING,payload:false})
        done('Could not place order')
      }

    }
    catch(err){
      console.log({err})
      dispatch({type:SET_LOADING,payload:false})
      done(err)
    }
  }
}
